export default function wrapInnerBtn(string) {
  if (!string || !string.includes('btn')) return string;

  return string.replace(
    /(<[^>]*class=["'][^"']*\bbtn\b[^"']*["'][^>]*>)(?!\s*<span>)([\s\S]*?)(<\/[^>]+>)/g,
    '$1<span>$2</span>$3'
  );
}